import axios from "axios";
import { API } from "./uploads";

export async function getAdminStats() {
  const res = await axios.get(`${API}/admin/stats`);
  return res.data;
}

export async function getAdminUploads(params = {}) {
  const res = await axios.get(`${API}/admin/uploads`, { params });
  return res.data;
}

export async function getAdminChat(params = {}) {
  const res = await axios.get(`${API}/admin/chat`, { params });
  return res.data;
}

export async function getAdminFeedback(params = {}) {
  const res = await axios.get(`${API}/admin/feedback`, { params });
  return res.data;
}

export async function getAdminUsers(params = {}) {
  const res = await axios.get(`${API}/admin/users`, { params });
  return res.data;
}

/** Client-side CSV export — never sends data anywhere. */
export function downloadCSV(filename, rows, columns) {
  if (!rows || rows.length === 0) return;
  const cols = columns || Object.keys(rows[0]);
  const esc = (v) => {
    if (v === null || v === undefined) return "";
    const s = Array.isArray(v) ? v.join("|") : typeof v === "object" ? JSON.stringify(v) : String(v);
    if (s.includes(",") || s.includes('"') || s.includes("\n")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const header = cols.join(",");
  const body = rows.map((r) => cols.map((c) => esc(r[c])).join(",")).join("\n");
  const blob = new Blob([header + "\n" + body], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
